import {Path} from "d3-path";

export function withPath(shape) {
  let digits = 3;

  shape.digits = function(_) {
    if (!arguments.length) return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d = Math.floor(_);
      if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    return shape;
  };

  return () => new Path(digits);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/path.js
// module id = 53
// module chunks = 0